import appconfig from '@/utils/appConfig';
import clsx from 'clsx';
import { ReactNode, useState } from 'react';
import { FaMinusSquare, FaPlusSquare } from 'react-icons/fa';

interface AccordionProps {
    title: string;
    content: ReactNode;
    lastItem?: boolean;
}

const Accordion = ({ title, content, lastItem }: AccordionProps) => {
    const [expanded, setExpanded] = useState(false);
    const toggleExpanded = () => setExpanded((current) => !current);

    const containerClasses = clsx(
        'py-2',
        'text-left',
        'items-center',
        'select-none',
        'flex',
        'justify-between',
        'flex-row',
        'border-l-2',
        expanded
            ? `${appconfig.colors.coloredSectionBorder} bg-green-50`
            : 'border-transparent'
    );

    const outerClasses = clsx(
        'my-2',
        'sm:my-2',
        'md:my-4',
        // Only add bottom border if not the last item
        !lastItem && 'border-b',
        'border-gray-300',
        'cursor-pointer',
        'bg-white'
    );

    const ICON_SIZE = 24;

    return (
        <div className={outerClasses} onClick={toggleExpanded}>
            <div className={containerClasses}>
                <h5 className="flex-1 text-lg font-bold pl-4">{title}</h5>
                <div className="flex-none pl-2 text-3xl pr-4">
                    {expanded ? (
                        <FaMinusSquare size={ICON_SIZE} />
                    ) : (
                        <FaPlusSquare size={ICON_SIZE} />
                    )}
                </div>
            </div>
            <div
                className={`px-4 pt-0 mb-2 overflow-hidden transition-[max-height] duration-300 ease-in ${expanded ? 'max-h-[2000px]' : 'max-h-0'}`}
            >
                <div className="py-4 text-left">{content}</div>
            </div>
        </div>
    );
};

export default Accordion;
